import type { ApolloQueryResult } from '@apollo/client'

import apolloClient from '../../lib/apolloClient'
import { GET_MARKET_BY_ID_QUERY } from '../queries'
import { GetMarketByIdQuery, GetMarketByIdQueryVariables } from '../__generated__/types'

export const fetchMarketById = (id: string): Promise<ApolloQueryResult<GetMarketByIdQuery>> => {
  return apolloClient.query<GetMarketByIdQuery, GetMarketByIdQueryVariables>({
    query: GET_MARKET_BY_ID_QUERY,
    variables: {
      id,
    },
  })
}
